function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M70.9 21.3L0 66.5l70.9 45.1 70.8-45.1-70.8-45.2zm141.7 0l-70.9 45.2 70.9 45.1 70.9-45.1-70.9-45.2zM0 156.8l70.9 45.1 70.8-45.1-70.8-45.2L0 156.8zm212.6-45.2l-70.9 45.2 70.9 45.1 70.9-45.1-70.9-45.2zM70.9 217l70.8 45.1 70.9-45.1-70.9-45.2L70.9 217z"
})));